import React from 'react';
import { Route, Switch } from 'react-router-dom';

export default function Router(props) {
  const { models, options } = props;

  return (
    <Switch>
      <Route exact path="/:region(us|cn)/:entry(configurator|design)/:year/:model/model" component={models} />
      <Route path="/:region(us|cn)/:entry(configurator|design)/:year/:model" component={options} />
    </Switch>
  );
}

export function SidebarRouter(props) {
  const { children: optionsSidebar, summarySidebar } = props;
  return (
    <Switch>
      <Route exact path='/:region(us|cn)/:entry(configurator|design)/:year/:model/options'>
        {optionsSidebar}
      </Route>
      <Route exact path='/:region(us|cn)/:entry(configurator|design)/:year/:model/summary' component={summarySidebar} />
    </Switch>
  )
}
